import { format, isEqual, isWithinInterval } from 'date-fns';
import { FORMAT_DATE } from '../../constants';

const SEARCH_OPTIONS = [
  { label: 'Usuario', value: 'user', placeholder: 'Buscar por usuario' },
  { label: 'Doc. identidad', value: 'document', placeholder: 'Buscar por doc. identidad' },
  { label: 'Correo', value: 'email', placeholder: 'Buscar por correo' },
];

const SELECT_ESTADO_OPTIONS = [
  { label: 'Activo', value: true },
  { label: 'Inactivo', value: false },
];

const generateFilter = ({ filter, status, date, role }) => {
  let applyFilter = {};

  if (filter) {
    applyFilter = filter.reduce((acc, { key, search }) => {
      let newFilter = {};
      const option = SEARCH_OPTIONS.find(({ label }) => label === key);
      if (option) {
        newFilter = { [option.value]: search };
      }
      return { ...acc, ...newFilter };
    }, {});
  }
  if (status !== undefined) {
    applyFilter = { ...applyFilter, status: status?.value };
  }

  if (date) {
    applyFilter = { ...applyFilter, fechaExpedicionDesde: format(date[0], FORMAT_DATE.FILTER) };
    if (date[1] !== null) {
      applyFilter = { ...applyFilter, fechaExpedicionHasta: format(date[1], FORMAT_DATE.FILTER) };
    }
  }

  if (role) {
    applyFilter = { ...applyFilter, role: role.map(({ value }) => value) };
  }

  return applyFilter;
};

const localFilterData = ({ data, filter }) => {
  if (!filter) {
    return data;
  }

  let dataFiltered = data;
  if (filter.user) {
    dataFiltered = dataFiltered.filter(({ name, lastname1, lastname2 }) => {
      let fullName = 'Anónimo';
      if (name) {
        fullName = `${name} ${lastname1}${lastname2 ? ` ${lastname2}` : ''}`;
      }
      return fullName.toLowerCase().includes(filter.user.toLowerCase());
    });
  }
  if (filter.email) {
    dataFiltered = dataFiltered.filter(({ email }) => email?.toLowerCase().includes(filter.email));
  }
  if (filter.document) {
    dataFiltered = dataFiltered.filter(({ document }) => document?.toLowerCase().includes(filter.document));
  }

  if (filter.status !== undefined) {
    dataFiltered = dataFiltered.filter(({ active }) => (filter.status ? active : !active));
  }

  if (filter.role) {
    dataFiltered = data.filter(({ role }) => filter.role.includes(role));
  }

  if (filter.fechaExpedicionDesde && !filter.fechaExpedicionHasta) {
    dataFiltered = dataFiltered.filter(({ creationDate }) =>
      isEqual(new Date(format(new Date(creationDate), FORMAT_DATE.FILTER)), new Date(filter.fechaExpedicionDesde))
    );
  }

  if (filter.fechaExpedicionHasta) {
    dataFiltered = dataFiltered.filter(({ creationDate }) =>
      isWithinInterval(new Date(format(new Date(creationDate), FORMAT_DATE.FILTER)), {
        start: new Date(filter.fechaExpedicionDesde),
        end: new Date(filter.fechaExpedicionHasta),
      })
    );
  }

  return dataFiltered;
};

export { SEARCH_OPTIONS, SELECT_ESTADO_OPTIONS, localFilterData, generateFilter };
